import React from "react";
import { useHistory } from "react-router";
import { SiteCard } from "../submodules/Sites/SiteCard";

export function NewSitePage() {
  const history = useHistory();
  const handleCancel = () => history.goBack();
  return <SiteCard handleCancel={handleCancel} />;
}
